import { put, takeEvery } from 'redux-saga/effects';
import { ProjectId, UserId } from 'api/models';
import { ProjectAPI } from 'api/project';
import { updateProjectMembers } from 'data/projects/actions';
import { add } from 'stores/memberships';
function* updateProjectMembersSaga(action) {
    const { payload } = action;
    const { projectId, members, handleSuccess, handleFailure } = payload;
    try {
        const response = yield ProjectAPI.updateMembers(projectId, members);
        if (handleSuccess) {
            handleSuccess(payload);
        }
        yield put(add({
            projectId: ProjectId(projectId),
            memberships: response.map(({ user: { userId }, permissionSet: { permissionSetType: memberType }, joinedAt })=>({
                    userId: UserId(userId),
                    memberType,
                    joinedAt
                }))
        }));
    } catch (error) {
        if (handleFailure) {
            handleFailure(error);
        }
    }
}
export const watchUpdateProjectMembersSaga = function*() {
    yield takeEvery(updateProjectMembers.type, updateProjectMembersSaga);
};
